import { normalizeAuditList } from "./normalizeAuditRecord";

const isWeightAuditType = (auditType) =>
  (auditType || "").toString().toUpperCase() === "WEIGHT";

const withWeightDiff = (event) => {
  if (!isWeightAuditType(event?.auditType)) {
    return event;
  }
  if (event?.weightDiff != null) {
    return event;
  }
  const audited = event?.auditedWeight;
  const booked = event?.bookedWeight;
  if (audited == null || booked == null || audited === 0) {
    return event;
  }
  return {
    ...event,
    weightDiff: ((audited - booked) / audited) * 100,
  };
};

export const enrichShipmentTrackingAuditInfo = (trackingData, auditEvents) => {
  if (!trackingData || !Array.isArray(auditEvents)) {
    return trackingData;
  }

  if (!trackingData.shipmentTracking) {
    return trackingData;
  }

  const enrichedAuditInfo = normalizeAuditList(auditEvents).map(withWeightDiff);

  return {
    ...trackingData,
    shipmentTracking: {
      ...trackingData.shipmentTracking,
      auditInfo: enrichedAuditInfo,
    },
  };
};

export const resolveTrackingAwbNumber = (trackingData, fallbackAwb) =>
  trackingData?.shipmentTracking?.bookingInfoDto?.awbNumber || fallbackAwb;
